module.exports = __webpack_public_path__ + "img/greater_chaos_citadel_small.666b4115.png";